import { mathFactsPlayableLauncher } from "./mathFactsPlayableLauncher";
import { playableLauncher } from "./playableLauncher";
import { redirectionHandler } from "./redirectionHandler";
export var getActionHandler = function (actionCode) {
    if (actionCode)
        switch (actionCode) {
            case 'playable_launcher':
                return playableLauncher;
            case 'math_facts_playable_launcher':
                return mathFactsPlayableLauncher;
            case 'redirect':
                return redirectionHandler;
            case 'default':
                return function () { };
        }
    return function () { };
};
